// Swaps the address in place (no new history entry) and tells anything
// reading the address that it changed, since history.replaceState fires no
// event of its own. The top bar's bookmark star listens for it, so it fills
// in or empties as a page's filters change.
export const URL_REPLACED_EVENT = "atlas:url-replaced"

export function replaceUrl(url: string | URL, state: unknown = window.history.state) {
  window.history.replaceState(state, "", url.toString())
  window.dispatchEvent(new Event(URL_REPLACED_EVENT))
}
